module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village//result-winner-bg.png?v=5fbb4aed";